export const isValidEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};
export const formatDate = (dateString) => {
    if (!dateString)
        return '';
    // need for Safari: Replace space with 'T' to conform to ECMA-262 standard ()
    const standardizedDateString = dateString.replace(' ', 'T') + 'Z';
    const inputDate = new Date(standardizedDateString);
    const userLocale = navigator.language || 'en-US';
    const now = new Date();
    const todayUTC = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    const inputDayUTC = new Date(Date.UTC(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate()));
    if (inputDayUTC >= todayUTC) {
        return inputDate.toLocaleTimeString(userLocale, { hour: '2-digit', minute: '2-digit' });
    }
    else {
        return inputDate.toLocaleString(userLocale, { hour: '2-digit', minute: '2-digit', day: 'numeric', month: 'short' });
    }
};
export const truncateMiddle = (str, max = 15) => {
    if (str.length <= max)
        return str;
    const splitAt = Math.floor(max / 2);
    const start = str.slice(0, splitAt);
    const end = str.slice(-splitAt);
    return `${start}...${end}`;
};
export const isImageFile = (fileName) => fileName.endsWith('.png') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg');
